import { render, staticRenderFns } from "./IncomeExpenses.vue?vue&type=template&id=10f82d99&"
import script from "./IncomeExpenses.vue?vue&type=script&lang=js&"
export * from "./IncomeExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports